<template>
  <el-tooltip :visible="confirmationVisible" placement="bottom" content="Copied!">
    <button
      type="button"
      class="toolbar-button"
      :title="confirmationVisible ? null : 'Copy response'"
      aria-label="Copy response"
      @click="copyResponse"
    >
      <!-- eslint-disable-next-line vue/no-v-html -->
      <span class="toolbar-icon" v-html="faCopyIcon" />
    </button>
  </el-tooltip>
</template>

<script setup>
// Rendered inside the ChatbotResponseToolbar custom element, which is where the shared
// .toolbar-button and .toolbar-icon styles come from.
import { inject, onBeforeUnmount, ref } from 'vue';
import { ElTooltip } from 'element-plus';
import faCopyIcon from '@fortawesome/fontawesome-pro/svgs/light/copy.svg?raw';
import { getResponseTextToCopy } from '@/utils/chatbotResponseText';

const { traceId } = defineProps({
  traceId: String,
});

const deepChatRef = inject('deepChatRef');

// How long the "Copied!" confirmation stays open.
const COPIED_TOOLTIP_DURATION_MS = 1500;
const confirmationVisible = ref(false);
let copiedTimeout = null;

async function copyResponse() {
  const text = getResponseTextToCopy(deepChatRef.value?.getMessages(), traceId);
  if (!text) {
    console.error('Cannot copy the response because its text could not be found.');
    return;
  }

  try {
    await navigator.clipboard.writeText(text);
  } catch (error) {
    console.error('Failed to copy the response to the clipboard.', error);
    return;
  }

  confirmationVisible.value = true;
  clearTimeout(copiedTimeout);
  copiedTimeout = setTimeout(() => {
    confirmationVisible.value = false;
  }, COPIED_TOOLTIP_DURATION_MS);
}

onBeforeUnmount(() => {
  clearTimeout(copiedTimeout);
});
</script>
